// Reception filter tabs — RON-5469. Prototype region: `#filter-tabs` (seven tabs).
//
// Reads the SAME `counts` object the stat tiles do (§3), so the two regions cannot disagree. The
// badges answer "how many are behind this tab" and therefore do not move with `filter` or `q` —
// only the rows narrow.
//
// The seven values are the API's, and a value outside them is a 422 listing all seven rather than
// an empty list. `all` is a real value, not the absence of one, so it is never stripped before the
// request is built.

import { useTranslation } from "react-i18next";

import { FILTER_TAB_ORDER, getFilterLabelKey } from "../receptionConstants.js";

// Tab key → the `counts` key behind it. `all` and `contractors` have no stat tile; the other five
// share theirs with one.
const COUNT_KEY_BY_FILTER = {
  all: "all",
  expected: "expected",
  on_site: "onSite",
  walk_ins: "walkIns",
  vip: "vip",
  contractors: "contractors",
  overstay: "overstay",
};

const ReceptionFilterTabs = ({ filter, counts, onFilterChange }) => {
  const { t } = useTranslation("common");

  return (
    <div className="reception-tabs" role="tablist">
      {FILTER_TAB_ORDER.map((value) => {
        const isActive = value === filter;

        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`reception-tab${isActive ? " reception-tab--active" : ""}`}
            onClick={() => onFilterChange?.(value)}
          >
            {t(getFilterLabelKey(value))}
            <span className="reception-tab__count">
              {counts?.[COUNT_KEY_BY_FILTER[value]] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ReceptionFilterTabs;
